<template>
  <div class="flex flex-col min-h-[100vh]">
    <TheHeader />
    <TheContainer class="flex-grow" />
    <TheFooter />
  </div>
</template>

<script setup lang="ts">
  import TheHeader from './TheHeader.vue'
  import TheContainer from '&/TheContainer.vue'
  import TheFooter from './TheFooter.vue'
</script>
